<ckeditor [editor]="Editor" data="<p>Hello, world!</p>">
</ckeditor>
